import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';

import css from './FoundingMemberBadge.module.css';

const FoundingMemberBadge = props => {
  const { className, rootClassName } = props;
  const classes = classNames(css.root, rootClassName, className);

  return (
    <span className={classes}>
      <FormattedMessage id="FoundingMemberBadge.label" defaultMessage="Founding Member" />
    </span>
  );
};

const { string } = PropTypes;

FoundingMemberBadge.defaultProps = {
  className: null,
  rootClassName: null,
};

FoundingMemberBadge.propTypes = {
  className: string,
  rootClassName: string,
};

export default FoundingMemberBadge;
